import { client } from "@hey-api/client-fetch";
const healthcheckCreditHealthcheckGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get(
    {
      ...options,
      url: "/credit/healthcheck/"
    }
  );
};
const listBanksGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/banks/"
  });
};
const retrieveBanksBankIdGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/banks/{bank_id}/"
  });
};
const programListFinancialProgramsGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get(
    {
      ...options,
      url: "/financial-programs/"
    }
  );
};
const getPaymentsFinancialProgramsPaymentsGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/financial-programs/payments/"
  });
};
const getLimitsFinancialProgramsLimitsGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/financial-programs/limits/"
  });
};
const retrieveFinancialProgramsFinancialProgramIdGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/financial-programs/{financial_program_id}/"
  });
};
const getListClientSettingsGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/client-settings/"
  });
};
const reloadClientSettingsReloadGet = (options) => {
  return ((options == null ? void 0 : options.client) ?? client).get({
    ...options,
    url: "/client-settings/reload"
  });
};
export {
  getLimitsFinancialProgramsLimitsGet,
  getListClientSettingsGet,
  getPaymentsFinancialProgramsPaymentsGet,
  healthcheckCreditHealthcheckGet,
  listBanksGet,
  programListFinancialProgramsGet,
  reloadClientSettingsReloadGet,
  retrieveBanksBankIdGet,
  retrieveFinancialProgramsFinancialProgramIdGet
};
